export const SUFFIX_TYPE = [
  {
    value: 'JR',
    label: 'Jr',
  },
  {
    value: 'SR',
    label: 'Sr',
  },
  {
    value: 'I',
    label: 'I',
  },
  {
    value: 'II',
    label: 'II',
  },
  {
    value: 'III',
    label: 'III',
  },
  {
    value: 'IV',
    label: 'IV',
  },
];

export const FULL_TIME = 'FULL_TIME';
export const PART_TIME = 'PART_TIME';
export const SELF_EMPLOYED = 'SELF_EMPLOYED';
export const RETIRED = 'RETIRED';
export const UNEMPLOYED = 'UNEMPLOYED';
export const SEPARATE_MAINTENANCE_PAYMENTS = 'SEPARATE_MAINTENANCE_PAYMENTS';

export const EMPLOYMENT_TYPE = [
  { value: FULL_TIME, label: 'Employed Full-Time' },
  { value: PART_TIME, label: 'Employed Part-Time' },
  { value: SELF_EMPLOYED, label: 'Self-employed' },
  { value: RETIRED, label: 'Retired' },
  { value: UNEMPLOYED, label: 'Unemployed/Furloughed' },
  {
    value: SEPARATE_MAINTENANCE_PAYMENTS,
    label: 'Alimony/Child Support/Separate Maintenance Payments/Public Assistance Program',
  },
];
